import { Outlet } from 'react-router';
import { AdminSidebar } from '../components/admin/sidebar';
import { getUser, clearToken, clearRefreshToken } from '../lib/auth';
import { useNavigate } from 'react-router';

export function AdminLayout() {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearToken();
    clearRefreshToken();
    navigate('/admin/login');
  };

  return (
    <div className="flex h-screen">
      <AdminSidebar role={user?.role || null} onLogout={handleLogout} />
      <main className="flex-1 overflow-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
